var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"blockchain-orders-container"},[_c('h1',[_vm._v("Blockchain Trades to be transferred")]),_vm._v(" "),(_vm.trades)?_c('trades-table',{attrs:{"b-trades":_vm.trades,"loading":_vm.loading}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb2c44a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/trades/BlockchainPendingTrades.vue
// module id = null
// module chunks = 